/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSubmissionPayloadDto
 */
export interface CreateSubmissionPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof CreateSubmissionPayloadDto
     */
    transactionType: CreateSubmissionPayloadDtoTransactionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateSubmissionPayloadDto
     */
    placingType: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubmissionPayloadDto
     */
    lineOfBusiness: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubmissionPayloadDto
     */
    policyType: CreateSubmissionPayloadDtoPolicyTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateSubmissionPayloadDto
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubmissionPayloadDto
     */
    assignedHandlerId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubmissionPayloadDto
     */
    namedUnderwriterId: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateSubmissionPayloadDto
     */
    inceptionDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateSubmissionPayloadDto
     */
    expiryDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof CreateSubmissionPayloadDto
     */
    principalOccupation?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubmissionPayloadDto
     */
    subClass: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubmissionPayloadDto
     */
    mainRegionAndRiskTerritory?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubmissionPayloadDto
     */
    keyRiskLocation?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubmissionPayloadDto
     */
    originalCurrency?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubmissionPayloadDto
     */
    status: CreateSubmissionPayloadDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateSubmissionPayloadDto
     */
    insuredId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSubmissionPayloadDto
     */
    fileIds?: Array<string>;
}


/**
 * @export
 */
export const CreateSubmissionPayloadDtoTransactionTypeEnum = {
    Renewal: 'Renewal',
    NewBusiness: 'New Business'
} as const;
export type CreateSubmissionPayloadDtoTransactionTypeEnum = typeof CreateSubmissionPayloadDtoTransactionTypeEnum[keyof typeof CreateSubmissionPayloadDtoTransactionTypeEnum];

/**
 * @export
 */
export const CreateSubmissionPayloadDtoPolicyTypeEnum = {
    Reinsurance: 'Reinsurance',
    Insurance: 'Insurance'
} as const;
export type CreateSubmissionPayloadDtoPolicyTypeEnum = typeof CreateSubmissionPayloadDtoPolicyTypeEnum[keyof typeof CreateSubmissionPayloadDtoPolicyTypeEnum];

/**
 * @export
 */
export const CreateSubmissionPayloadDtoStatusEnum = {
    Prospect: 'Prospect',
    Pending: 'Pending',
    Quoted: 'Quoted',
    Declined: 'Declined',
    Cancelled: 'Cancelled',
    Complete: 'Complete'
} as const;
export type CreateSubmissionPayloadDtoStatusEnum = typeof CreateSubmissionPayloadDtoStatusEnum[keyof typeof CreateSubmissionPayloadDtoStatusEnum];


/**
 * Check if a given object implements the CreateSubmissionPayloadDto interface.
 */
export function instanceOfCreateSubmissionPayloadDto(value: object): value is CreateSubmissionPayloadDto {
    if (!('transactionType' in value) || value['transactionType'] === undefined) return false;
    if (!('placingType' in value) || value['placingType'] === undefined) return false;
    if (!('lineOfBusiness' in value) || value['lineOfBusiness'] === undefined) return false;
    if (!('policyType' in value) || value['policyType'] === undefined) return false;
    if (!('assignedHandlerId' in value) || value['assignedHandlerId'] === undefined) return false;
    if (!('namedUnderwriterId' in value) || value['namedUnderwriterId'] === undefined) return false;
    if (!('inceptionDate' in value) || value['inceptionDate'] === undefined) return false;
    if (!('subClass' in value) || value['subClass'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('insuredId' in value) || value['insuredId'] === undefined) return false;
    return true;
}

export function CreateSubmissionPayloadDtoFromJSON(json: any): CreateSubmissionPayloadDto {
    return CreateSubmissionPayloadDtoFromJSONTyped(json, false);
}

export function CreateSubmissionPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSubmissionPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'transactionType': json['transactionType'],
        'placingType': json['placingType'],
        'lineOfBusiness': json['lineOfBusiness'],
        'policyType': json['policyType'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'assignedHandlerId': json['assignedHandlerId'],
        'namedUnderwriterId': json['namedUnderwriterId'],
        'inceptionDate': (new Date(json['inceptionDate'])),
        'expiryDate': json['expiryDate'] == null ? undefined : (new Date(json['expiryDate'])),
        'principalOccupation': json['principalOccupation'] == null ? undefined : json['principalOccupation'],
        'subClass': json['subClass'],
        'mainRegionAndRiskTerritory': json['mainRegionAndRiskTerritory'] == null ? undefined : json['mainRegionAndRiskTerritory'],
        'keyRiskLocation': json['keyRiskLocation'] == null ? undefined : json['keyRiskLocation'],
        'originalCurrency': json['originalCurrency'] == null ? undefined : json['originalCurrency'],
        'status': json['status'],
        'insuredId': json['insuredId'],
        'fileIds': json['fileIds'] == null ? undefined : json['fileIds'],
    };
}

export function CreateSubmissionPayloadDtoToJSON(json: any): CreateSubmissionPayloadDto {
    return CreateSubmissionPayloadDtoToJSONTyped(json, false);
}

export function CreateSubmissionPayloadDtoToJSONTyped(value?: CreateSubmissionPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transactionType': value['transactionType'],
        'placingType': value['placingType'],
        'lineOfBusiness': value['lineOfBusiness'],
        'policyType': value['policyType'],
        'comment': value['comment'],
        'assignedHandlerId': value['assignedHandlerId'],
        'namedUnderwriterId': value['namedUnderwriterId'],
        'inceptionDate': ((value['inceptionDate']).toISOString()),
        'expiryDate': value['expiryDate'] == null ? undefined : ((value['expiryDate']).toISOString()),
        'principalOccupation': value['principalOccupation'],
        'subClass': value['subClass'],
        'mainRegionAndRiskTerritory': value['mainRegionAndRiskTerritory'],
        'keyRiskLocation': value['keyRiskLocation'],
        'originalCurrency': value['originalCurrency'],
        'status': value['status'],
        'insuredId': value['insuredId'],
        'fileIds': value['fileIds'],
    };
}

